import { render } from "./Analysis.vue?vue&type=template&id=ae8be95a&scoped=true"
import script from "./Analysis.vue?vue&type=script&lang=js"
export * from "./Analysis.vue?vue&type=script&lang=js"

import "./Analysis.vue?vue&type=style&index=0&id=ae8be95a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ae8be95a"

export default script